// src/pages/TransferEntry/index.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App } from "antd";
import { useParams } from "react-router-dom";
import CreateTransferForm from "./components/CreateTransferForm";
import {
  selectTransferVoucherNo,
  selectTransferItems,
  selectFooterValues,
} from "./TransferEntrySelectors";
import {
  fetchTransferVoucherNo,
  createTransferEntry,
  fetchOtherBranchList,
  fetchTransferById,
} from "./TransferEntryThunk";
import { setResetTransfer, setFormField } from "./TransferEntrySlice";
import { useForm } from "antd/es/form/Form";
import { fetchItems } from "../../store/commonThunks/lookups";
import "./index.scss";

const TransferEntry = ({authInfo}) => {
  const { message, modal } = App.useApp();
  const dispatch = useDispatch();
  const [form] = useForm();
  
  const { id: t_id } = useParams();

  const voucherNo = useSelector(selectTransferVoucherNo);
  const itemsList = useSelector(selectTransferItems);
  const footerValues = useSelector(selectFooterValues);

  

  const handleSave = () => {
    if (!itemsList.length || !itemsList[0].item_id) {
      message.warning("Please add at least one item!");
      return;
    }
    if ((itemsList[0].quantity || 0) <= 0) {
      message.warning("Enter valid quantity!");
      return;
    }

    dispatch(createTransferEntry())
      .unwrap()
      .then((res) => {
        modal.success({ title: "Transfer Saved Successfully!" });
        dispatch(setResetTransfer());
        form.resetFields();
        dispatch(fetchTransferVoucherNo());
        dispatch(fetchOtherBranchList());
      })
      .catch(() => message.error("Save failed!"));
  };  

  // dispatch(
      //   setFormField({
      //     field: "branchDetails",
      //     value: {
      //       id: br.sale_id,
      //       name: br.display_text,
      //       address: br.address,
      //     },
      //   })
      // );

  useEffect(() => {
    dispatch(fetchItems());
    dispatch(fetchOtherBranchList());
    if (t_id) {
      dispatch(fetchTransferById(t_id))
      .unwrap()
      .then((data) => {
              dispatch(setFormField({
          field: "branchDetails",
          value: {
            id: data.to_branch_id,
            name: data.to_branch_name,
            address: data.to_branch_address,
          },
        }));

        form.setFieldsValue({
          to_branch: data.to_branch_id,
        });
    });    
  }
     else {
      dispatch(setResetTransfer());
      dispatch(fetchTransferVoucherNo());
    }
  }, [dispatch, t_id]);

  return (
    <CreateTransferForm
      form={form}
      onSave={handleSave}
      voucherNo={voucherNo}
      itemsList={itemsList}
      footerValues={footerValues}
      authInfo={authInfo}
    />
  );
};

export default TransferEntry;
